<template>
  <router-view />
</template>

<script>
import store, { name } from '@/modules/provider/store';

export default {
  name: 'MedicaidWrapper',
  data: () => ({
    page: {
      title: 'Medicaid',
      icon: 'fas fa-user-tie',
      routes: ['Medicaid'],
    },
  }),
  provide() {
    return {
      page: this.page,
    };
  },
  created() {
    this.$store.registerModule(name, store);
  },
  destroyed() {
    this.$store.unregisterModule(name);
  },
};
</script>
